import { useState, type FormEvent, type KeyboardEvent } from "react";

interface Props {
  onSubmit: (text: string) => Promise<void> | void;
  placeholder?: string;
  disabled?: boolean;
}

export function GuessInput({ onSubmit, placeholder, disabled }: Props) {
  const [value, setValue] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(e?: FormEvent) {
    e?.preventDefault();
    const text = value.trim();
    if (!text || submitting || disabled) return;
    setSubmitting(true);
    try {
      await onSubmit(text);
      setValue("");
    } finally {
      setSubmitting(false);
    }
  }

  function onKey(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === "Enter") void submit();
  }

  return (
    <form onSubmit={submit} className="relative">
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={onKey}
        placeholder={placeholder ?? "type your guess…"}
        disabled={disabled}
        autoFocus
        spellCheck={false}
        autoComplete="off"
        className="w-full px-5 py-4 pr-28 rounded-2xl glass text-lg font-mono placeholder:text-ink-400 focus:ring-2 focus:ring-accent/60 transition"
      />
      <button
        type="submit"
        disabled={!value.trim() || submitting || disabled}
        className="absolute right-2 top-1/2 -translate-y-1/2 px-4 py-2 rounded-xl bg-accent/90 text-ink-950 font-medium hover:bg-accent disabled:opacity-30 disabled:cursor-not-allowed transition"
      >
        {submitting ? "…" : "guess"}
      </button>
    </form>
  );
}
